import translations from './translations'

translations.add('pt', {
    changePaymentMethod: 'mudar o método de pagamento',
    firstTokenizationDescription: 'Registo do cartão',
    firstVerificationDescription: 'Verificação do cartão',
    secondaryOrderInfoDescription: 'Não será cobrado',
    tryAgain: 'Tente novamente'
})
